import { useLocale, useTranslation } from '@dreamstack/i18n'
import { DocumentDownload } from '@dreamstack/icons/src/icon-components/DocumentDownload'
import { getPropstackDocumentViewerUrl } from '@dreamstack/propstack-document-viewer'
import { SimpleDefinitionList } from '@dreamstack/simple-components/src/lib/SimpleDefinitionList'
import type { FullProject } from '@dreamstack/web/lib/prisma/projects'
import first from 'lodash/first'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { FileDownloadInline } from '../ActionTile'

export const ProjectInformationListBrochure: FunctionComponent<
  React.PropsWithChildren<{
    project?: FullProject
  }>
> = ({ project }) => {
  const t = useTranslation()
  const locale = useLocale()

  // TODO: any logic how to find the brochure in the docs? tags?
  // get bruchureDoc, when locale = en, get the first document which has "english" in the doc title
  // when locale = de, get the first document which has "deutsch" in the doc title
  // when not found, get the first document
  // this should also work when the document title only contain "en" or "de" since we are using "includes"

  const brochureDoc =
    first(
      project?.project_documents.filter((doc) =>
        doc.title?.toLowerCase().includes(locale)
      )
    ) || first(project?.project_documents)
  const showBrochure = !!brochureDoc && !brochureDoc.is_private
  if (!showBrochure) return null

  // TODO: get file size?
  const formattedFileSize = undefined
  const formattedFileType = 'PDF'
  const brochureHref = getPropstackDocumentViewerUrl({
    documentId: brochureDoc?.id,
  })

  return (
    <SimpleDefinitionList
      className="col-span-2 md:col-span-1"
      big
      dt={t('accentro:brochure')}
      dd={
        <Link href={brochureHref} passHref legacyBehavior>
          <a className="cursor-pointer" target="_blank" rel="noreferrer">
            <FileDownloadInline
              small
              caption={formattedFileType}
              icon={<DocumentDownload className="h-px-32 w-px-32" />}
              fileSize={formattedFileSize}
            />
          </a>
        </Link>
      }
    />
  )
}
